import React, { useMemo, useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useGetDealerDropdownListQuery } from '../../api/endpoints/dealer';

/**
 * Alınan Teminatlar ekranındaki bayi seçimi.
 * docs/CollateralReceived-API.md §2.2: `GET /v1/Dealer/GetDealerDropdownList` — projede zaten
 * kullanılan `DealerDropdown.jsx` ile aynı uç, fakat o bileşen seçenek olarak yalnızca dahili
 * `dealerId`'yi taşıyor. Bu ekranın gövdesi `sapDealerId` beklediğinden (doc §2.2: "value →
 * sapDealerId", gövdeye **string** olarak yazılır) ayrı, ince bir eşleme katmanı gerekti —
 * `DealerDropdown.jsx`'i (12 tüketicisi var) değiştirmek yerine küçük bir wrapper tercih edildi.
 *
 * Not: arama sonucu yoksa uç `NOT_FOUND` (404) döner (boş dizi değil) — bu normal bir durumdur,
 * hata olarak gösterilmez; seçenekler sessizce boş kalır.
 */
const CollateralDealerDropdown = ({ value, onChange, className, placeholder, disabled = false, rowCount = 20 }) => {
    const [searchText, setSearchText] = useState('');

    const { data: raw, isFetching } = useGetDealerDropdownListQuery({
        SearchText: searchText,
        RowCount: rowCount
    });

    const options = useMemo(() => {
        const items = Array.isArray(raw) ? raw : [];
        return items
            .filter((d) => d?.sapDealerId != null)
            .map((d) => ({
                label: d.name || d.translatedText || String(d.sapDealerId),
                value: String(d.sapDealerId)
            }));
    }, [raw]);

    return (
        <Dropdown
            value={value || null}
            onChange={(e) => onChange?.(e.value ?? null)}
            options={options}
            optionLabel="label"
            optionValue="value"
            onFilter={(e) => setSearchText(e.filter)}
            filter
            showClear
            className={className}
            placeholder={placeholder}
            loading={isFetching}
            disabled={disabled}
            appendTo={document.body}
        />
    );
};

export default CollateralDealerDropdown;
